import { Spinner } from '@material-tailwind/react'
import React from 'react'

export default function ASpinner() {
    return (
        <div className=' absolute z-40 top-0 bg-gray-600/50 rounded-lg flex items-center justify-center w-full h-[90%]'>
            <p className='  top-1/2 left-1/3  px-4 py-2 rounded-full bg-main-color mt-5 text-center flex text-white gap-2'> Loading ... <Spinner color="red" /> </p>
        </div>


    )
}
